// extracted by mini-css-extract-plugin
export default {"nav":"Menu_nav__tZVXm","list":"Menu_list__0hR7v","item":"Menu_item__oU2UN","horizontal":"Menu_horizontal__ypgcH","footer__menu":"Menu_footer__menu__u-CGq"};